import React from "react";
import { Outlet } from "react-router-dom";
import { InternalPopups } from "@features/InternalPopups/InternalPopups";
import { InternalFooter } from "@components/InternalFooter/InternalFooter";
import { Maintenance } from "@components/Maintenance/Maintenance";
import { Modals } from "@components/Modal/Modals";
import { Sidebar } from "@components/Sidebar/Sidebar";
import { useCustomerSelfServiceApiStatus } from "@hooks/useApiStatus";
import { useRequiredDataHandler } from "@hooks/useRequiredDataHandler";

const InitialLoader = React.lazy(() =>
  import("@components/InitialLoader/InitialLoader").then((module) => ({
    default: module.InitialLoader,
  })),
);

export const InternalLayout: React.FC = () => {
  const requiredDataFilled = useRequiredDataHandler();
  const { isApiAvailable } = useCustomerSelfServiceApiStatus();

  return (
    <InitialLoader>
      <Sidebar />
      <Modals />
      <InternalPopups />
      {/* 1840px = 1280px(max-w-screen-xl) + 280px(sidebar) * 2 */}
      <div className="flex bg-background-grey lg:max-[1840px]:pl-[17.5rem] min-[1840px]:justify-center">
        <main className="flex max-w-screen-xl flex-1 flex-col">
          <div className="flex min-h-[calc(100dvh_-_90px)] flex-col pb-5 md:px-8 md:pb-10">
            {isApiAvailable ? (
              requiredDataFilled && <Outlet />
            ) : (
              <Maintenance />
            )}
          </div>
          <div className="px-4 md:px-8">
            <InternalFooter />
          </div>
        </main>
      </div>
    </InitialLoader>
  );
};
